const firstPassword = '#target_salesperson_newPassword_first';
const secondPassword = '#target_salesperson_newPassword_second';
const submitBtn = '#target_salesperson_submit';

$(function() {
    $(submitBtn).addClass('disabled');
    if (window.location.pathname.indexOf('/newPassword') >= 0) {
        $(".general-footer").css('position', 'fixed').css('bottom', '0');
    }
});

$(document).on('focusout', firstPassword, function () {
    validatePassword($(this).val());
});

$(document).on('input', firstPassword, function () {
    const password = $(this).val();
    if (password.length < 8) {
        return;
    }
    validatePassword(password);
});

$(document).on('click', '#toggle-password', function () {
    const input = $(firstPassword);
    const type = input.attr('type') === 'password' ? 'text' : 'password';
    input.attr('type', type);
    $(this).text(type === 'password' ? 'Afficher' : 'Masquer');
});

$(document).on('input', '#target_salesperson_newPassword_first, #target_salesperson_newPassword_second',
    function () {
    if ($('#password-status').hasClass('valid') && $(firstPassword).val() === $(secondPassword).val()) {
        $(submitBtn).removeClass('disabled');
    } else {
        $(submitBtn).addClass('disabled');
    }
});

function validatePassword(password) {
    // const password = $(this).val();
    const minLength = password.length >= 8;
    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=~`]/.test(password);

    if (minLength && hasUpper && hasLower && hasDigit && hasSpecial) {
        $('#password-status')
            .text('Mot de passe valide ✅')
            .removeClass('invalid')
            .addClass('valid');
    } else {
        $('#password-status')
            .text('Mot de passe invalide ❌')
            .removeClass('valid')
            .addClass('invalid');
    }
}
